export default "__VITE_ASSET__DQU16mwh__"